import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { PiggyBank, Building2, Wallet, TrendingUp, Coins, Menu, X } from 'lucide-react';
import Logo from './shared/Logo';

const Navigation: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const links = [
    { to: '/retirement', icon: <PiggyBank size={20} />, text: 'Retirement' },
    { to: '/401k', icon: <Building2 size={20} />, text: '401(k)' },
    { to: '/roth-ira', icon: <Wallet size={20} />, text: 'Roth IRA' },
    { to: '/inflation', icon: <TrendingUp size={20} />, text: 'Inflation' },
    { to: '/dividend', icon: <Coins size={20} />, text: 'Dividends' },
  ];

  return (
    <nav className="bg-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Logo />
          </div>
          
          {/* Mobile menu button */}
          <div className="flex items-center lg:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-emerald-500"
              aria-expanded={isMenuOpen}
              aria-label={isMenuOpen ? "Close menu" : "Open menu"}
            >
              <span className="sr-only">{isMenuOpen ? "Close menu" : "Open menu"}</span>
              {isMenuOpen ? <X size={24} aria-hidden="true" /> : <Menu size={24} aria-hidden="true" />}
            </button>
          </div>

          {/* Desktop navigation */}
          <div className="hidden lg:flex lg:space-x-8">
            {links.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium ${
                    isActive
                      ? 'border-emerald-500 text-gray-900'
                      : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                  }`
                }
              >
                <span className="mr-2" aria-hidden="true">{link.icon}</span>
                {link.text}
              </NavLink>
            ))}
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div 
        className={`lg:hidden ${isMenuOpen ? 'block' : 'hidden'}`}
        role="navigation"
        aria-label="Mobile navigation"
      >
        <div className="pt-2 pb-3 space-y-1">
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              onClick={() => setIsMenuOpen(false)}
              className={({ isActive }) =>
                `block pl-3 pr-4 py-2 border-l-4 text-base font-medium ${
                  isActive
                    ? 'bg-emerald-50 border-emerald-500 text-emerald-700'
                    : 'border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700'
                }`
              }
            >
              <div className="flex items-center">
                <span className="mr-2" aria-hidden="true">{link.icon}</span>
                {link.text}
              </div>
            </NavLink>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;